"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRetailLocationDeliveryDetails = void 0;
const react_1 = require("react");
const SalesOrderContext_1 = require("../contexts/SalesOrderContext");
const TSalesOrderType_1 = require("../types/TSalesOrderType");
const OrderTypeContext_1 = require("../contexts/OrderTypeContext");
const location_1 = require("../../../../helpers/location");
const useRetailLocationDeliveryDetails = (retailLocation) => {
    const { totalPrice, salesOrderItems } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const { orderType } = (0, react_1.useContext)(OrderTypeContext_1.OrderTypeContext);
    const hasFulfilledMinimumDeliveryAmount = (0, react_1.useMemo)(() => {
        if (!retailLocation) {
            return false;
        }
        if (orderType === TSalesOrderType_1.TSalesOrderType.Pickup) {
            return true;
        }
        const { minimumDeliveryAmount, deliveryCost } = retailLocation;
        if (!minimumDeliveryAmount) {
            return true;
        }
        const serviceFeeItem = salesOrderItems.find(SO => SO.productId === "SERVICE");
        const serviceFee = serviceFeeItem ? serviceFeeItem.totalPrice : 0;
        return totalPrice - deliveryCost - serviceFee >= minimumDeliveryAmount;
    }, [orderType, totalPrice, retailLocation]);
    const showMinimumAmountMsg = (0, react_1.useMemo)(() => !hasFulfilledMinimumDeliveryAmount, [hasFulfilledMinimumDeliveryAmount]);
    const isValidDeliveryAddress = (0, react_1.useCallback)((deliveryAddress) => {
        if (orderType !== TSalesOrderType_1.TSalesOrderType.Delivery) {
            return true;
        }
        return (0, location_1.isCompleteLocationAddress)(deliveryAddress);
    }, [orderType]);
    return (0, react_1.useMemo)(() => ({
        hasFulfilledMinimumDeliveryAmount,
        showMinimumAmountMsg,
        isValidDeliveryAddress
    }), [
        hasFulfilledMinimumDeliveryAmount,
        showMinimumAmountMsg,
        isValidDeliveryAddress
    ]);
};
exports.useRetailLocationDeliveryDetails = useRetailLocationDeliveryDetails;
//# sourceMappingURL=useRetailLocationDeliveryDetails.js.map